import { Config } from '@catalogo/core-configuration';
import { PageLoadEvent, ModalEvent } from '../../../types/events';
import { ModalOpenDatalayer } from '../../../types/datalayer/modal-open';
import { eventData } from '../../../types/datalayer/datalayer';
import getDefaultEventPayload from '../default-event';

export default (events: eventData, config: Config): void => {
  const modalEvents = events['modal:open'];
  const modalLength = events['modal:open']?.length - 1 ?? 0;
  const modalEvent = modalEvents[modalLength] as ModalEvent;
  const pageload = events['page:load'][0] as PageLoadEvent;
  const defaultEventPayload = getDefaultEventPayload(pageload, config);

  const event: ModalOpenDatalayer = {
    ...defaultEventPayload,
    event: 'modal_open',
    eventCategory: 'modal-open',
    eventAction: modalEvent.detail?.id,
    eventLabel: undefined,
    eventValue: undefined,
  };

  window.dataLayer = window.dataLayer || [{}];
  window.dataLayer.push(event);
};
